import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import type { Args as PopupInnerModalArgs } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

import type PopupModal from 'webapp/models-custom/popup/modal';

export interface Args extends PopupInnerModalArgs {
	model: PopupModal;
}

export default class ReportsPopupTourIntroComponent extends PopupInnerModalComponent<PopupData.Report.TourIntro> {
	@service('flow/tour/reports-pageless')
	declare pagelessTourService: Service.Flow.Tour.ReportsPageless;
	@service('flow/tour/reports-slides')
	declare slidesTourService: Service.Flow.Tour.ReportsSlides;
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;

	get isFirstReport(): boolean {
		return this.mmReportsService.normalReportModels.length <= 1;
	}

	get popupTitle(): string {
		if (this.isFirstReport) {
			return 'Ready to unlock the full potential of your reporting?';
		}
		return 'The new page format is here';
	}

	get popupContent(): string {
		if (this.isFirstReport) {
			return 'Opt-in for our Reports tour and discover how you can create a comprehensive write-up, add items you want to highlight and customize the report.';
		}
		return 'Share comprehensive write-ups with your stakeholders. Opt-in for our Reports tour and discover what’s new in Reports.';
	}

	get buttonText(): string {
		if (this.isFirstReport) {
			return 'Start the Reports tour';
		}
		return 'Show me around';
	}

	@action
	startTour(): void {
		if (this.isFirstReport) {
			// for first report users, enable both tours
			this.pagelessTourService.checkTour();
			// slides tour will be available when they switch to slides view
		} else {
			// for existing report users, only enable pageless tour and mark slides tours as done just in case
			this.slidesTourService.endAllTours();
			this.pagelessTourService.checkTour();
		}
		this.close();
	}

	@action
	skipTour(): void {
		// end both tours when user skips
		this.pagelessTourService.endAllTours();
		this.slidesTourService.endAllTours();
		this.close();
	}
	<template>
		<div class="content">
			<div class="popup-reports-tour__image">
				<img
					src="/images/placeholders/reports-tour.svg"
					width="400"
					height="161"
					alt="Reports preview"
				/>
			</div>

			<div class="popup-reports-tour__content">
				<h3 class="popup-reports-tour__title">{{this.popupTitle}}</h3>
				<p class="popup-reports-tour__description">
					{{this.popupContent}}
				</p>
			</div>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="I'd rather explore on my own"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.skipTour}}
					/>
					<SubmitButtonComponent
						@text={{this.buttonText}}
						@extraClass="save"
						@onTrigger={{this.startTour}}
					/>
				</div>
			</div>
		</div>
	</template>
}
